<template>
  <div>
    <el-form
      ref="formRef"
      :model="formData"
      label-width="135px"
      :rules="createFormRules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="活动名称" prop="campaignName">
            <el-input
              :disabled="flag == 3"
              v-model="formData.campaignName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="活动时间 从" prop="startDate">
            <el-date-picker
              :disabled="flag == 3"
              style="width: 50%"
              v-model="formData.startDate"
              type="date"
              placeholder="开始日期"
            >
            </el-date-picker>
            <span>(含)</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="(含) 至" prop="endDate">
            <!-- <span>(含)&nbsp;&nbsp;至</span> -->
            <el-date-picker
              :disabled="flag == 3"
              style="width: 50%"
              v-model="formData.endDate"
              type="date"
              placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="用户类型" prop="joinCustomerFlag">
            <el-select
              :disabled="flag == 3"
              v-model="formData.joinCustomerFlag"
              @change="changeJoinCustomerFlag"
            >
              <el-option
                v-for="item in customerType"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="formData.joinCustomerFlag == 14">
        <el-col :span="24">
          <el-form-item
            label="用户分组"
            prop="custGrpName"
            :rules="
              formData.joinCustomerFlag == 14
                ? [
                    {
                      required: true,
                      message: '请选择用户分组',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <div>
              <el-input
                style="width: 90%"
                readonly
                v-model="formData.custGrpName"
              ></el-input>
              <el-button @click="userGroupingShow = true" :disabled="flag == 3"
                >选择分组</el-button
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.joinCustomerFlag == 3">
        <el-col :span="24">
          <el-form-item
            label="会员等级"
            prop="custLvl"
            :rules="
              formData.joinCustomerFlag == 3
                ? [
                    {
                      type: 'array',
                      required: true,
                      message: '请至少选择一个会员等级',
                      trigger: 'change',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-checkbox
              :disabled="flag == 3"
              v-model="formData.custLvl"
              v-for="item in checkbooksData"
              :key="item.levelID"
              :value="item.levelID"
              :label="item.levelID"
            >
              {{ item.levelName_cn }}
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item label="领用限制">
          <el-col :span="10">
            <el-radio-group :disabled="flag == 3" v-model="formData.actLimit">
              <el-radio :label="0">无限制</el-radio>
              <el-radio :label="3">每人限领用</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="2" style="display: flex">
            <el-input
              :disabled="flag == 3 ? true : formData.actLimit != 3"
              v-model="formData.limitNum"
            ></el-input
            ><span>次</span>
          </el-col>
        </el-form-item>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="活动内容">
            <el-radio-group
              :disabled="flag == 3"
              v-model="formData.presentedKind"
            >
              <el-radio :label="0">礼券</el-radio>
              <el-radio :label="1" v-if="formData.joinCustomerFlag != 0"
                >券包</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.presentedKind == 0">
        <el-col :span="24">
          <el-form-item
            label="券库"
            prop="presentedqk"
            :rules="
              formData.presentedKind == 0
                ? [{ required: true, message: '请选择券库', trigger: 'blur' }]
                : [{ required: false }]
            "
          >
            <div class="xiaoguo">
              <el-input
                readonly
                v-model="formData.presentedqk"
                @click.native="Juankubtn"
              ></el-input>
              <el-button :disabled="flag == 3" @click="weachTher"
                >选择</el-button
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.presentedKind == 1">
        <el-col :span="24">
          <div class="xiaoguo">
            <el-form-item
              label="券包"
              prop="presentedqb"
              :rules="
                formData.presentedKind == 1
                  ? [
                      {
                        required: true,
                        message: '请选择券包',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-input
                readonly
                v-model="formData.presentedqb"
                style="width: 90%"
                @click.native="Juanbaobtn"
              ></el-input>
              <el-button
                :disabled="
                  flag == 3 ? true : formData.presentedKind == 1 ? false : true
                "
                @click="weachTherqb"
                >选择</el-button
              >
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="发放数量"
            prop="sendMaxQty"
            :rules="
              formData.presentedKind == 0 || formData.presentedKind == 1
                ? [
                    {
                      required: true,
                      message: '请输入发放数量',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-input :disabled="flag == 3" v-model="formData.sendMaxQty" placeholder="如果填0则表示不限制发放数量"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.presentedKind != 2">
        <el-col :span="24">
          <el-form-item label="抄送人员">
            <el-input
            :disabled="flag == 3"
              readonly
              style="width: 90%"
              v-model="formData.chaosong"
            ></el-input>
            <el-button :disabled="flag == 3" @click="sysempselectEmpList(), (innerVisiblery = true)"
              >选择</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flag == 3">
        <el-col :span="24">
          <el-form-item label="小程序领券链接">
            <el-input
            :disabled="flag == 3"
              readonly
              style="width: 90%"
              v-model="formData.coupURL"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flag == 3">
        <el-col :span="24">
          <el-form-item label="二维码">
            <el-image
            :disabled="flag == 3"
              style="
                width: 150px;
                height: 150px;
                margin: 5px 10px 0 0;
                border: 1px solid #e4e7ed;
              "
              :src="formData.coupQRCode"
              :preview-src-list="[formData.coupQRCode]"
            ></el-image>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="发放方式">
            <el-radio-group
                :disabled="flag == 3"
                v-model="formData.sendMode"
                @change="sendModeRadioChange"
            >
              <el-radio :label="0">立即发送</el-radio>
              <el-radio :label="1">定时发送</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item style="width: 57%" label="发放间隔天数"
                        :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                       message: '请输入发放间隔天数',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-input
                oninput="value=value.replace(/[^0-9]/g,'')"
                :disabled="
                flag == 3 ? true : formData.sendMode == 1 ? false : true
              "
                v-model="formData.disIntervalDay"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
              label="定时发送时间点"
              prop="issueTime"
              :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择定时发送时间',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-time-picker
                value-format="HH:mm:ss"
                style="width: 36%; margin-left: 10px"
                v-model="formData.issueTime"
                placeholder="任意时间点"
                :disabled="
                flag == 3 ? true : formData.sendMode == 1 ? false : true
              "
            >
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button v-if="flag != 3" @click="formRules">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>

    <!-- 选择劵库弹窗 -->
    <div>
      <el-dialog
        width="40%"
        title="选择券库"
        append-to-body
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
      >
        <el-form size="mini" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="券名称">
                <el-input v-model="queryArr.couponsName"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="券类型">
                <div class="flex-between">
                  <el-select style="width: 100%" v-model="queryArr.couponsKind">
                    <el-option label="全部" value=""> </el-option>
                    <el-option label="现金券" value="0"> </el-option>
                    <el-option label="折扣券" value="1"> </el-option>
                    <el-option label="礼品券" value="2"> </el-option>
                    <el-option label="异业券" value="3"> </el-option>
                  </el-select>
                  <el-button
                    icon="el-icon-search"
                    style="margin-left: 3%"
                    @click="Securitieslibrary()"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="queryArr.createTime"
                  type="date"
                  placeholder="选择时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="至">
                <el-date-picker
                  v-model="queryArr.updateTime"
                  type="date"
                  placeholder="选择时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width: 100%; margin-top: 10px">
          <el-table
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryList"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="load"
            v-loading="loading"
            infinite-scroll-disabled="onLoading"
          >
            <el-table-column width="40">
              <template slot-scope="scope">
                <el-radio
                  v-model="radioId"
                  :label="scope.$index"
                  @change.native="handleRadioChange(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="couponsName" label="券名称">
            </el-table-column>
            <el-table-column prop="innerCoupName" label="券后台名称">
            </el-table-column>
            <el-table-column prop="couponsKind" label="券类型">
              <template scope="scope">
                {{
                  scope.row.couponsKind === 0
                    ? " 现金券"
                    : "" || scope.row.couponsKind === 1
                    ? "折扣券"
                    : "" || scope.row.couponsKind === 2
                    ? "礼品券"
                    : "" || scope.row.couponsKind === 3
                    ? "异业券"
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="coupValue" label="券值"></el-table-column>
            <el-table-column prop="giftNo" label="礼品编号"></el-table-column>
            <el-table-column prop="giftName" label="礼品名称"></el-table-column>
            <el-table-column prop="createUserName" label="创建人">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template scope="scope">
                {{ scope.row.createTime | dateFormats }}
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMore"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="determine">确 定</el-button>
          <el-button @click="innerVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 选择券包 -->
    <div class="choice">
      <el-dialog
        width="35%"
        title="选择券包"
        append-to-body
        :visible.sync="innerVisibleqb"
      >
        <el-form size="mini" label-width="100px">
          <el-row>
            <el-col>
              <el-form-item label="券包名称">
                <el-input
                  style="width: 60%"
                  v-model="queryArrqb.coupPacketName"
                ></el-input>
                <el-button
                  icon="el-icon-search"
                  style="margin-left: 3%"
                  @click="Seachbtnerqb"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="width: 100%">
          <el-table
            size="mini"
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryListqb"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="loadqb"
            v-loading="loadingqb"
            infinite-scroll-disabled="onLoadingqb"
          >
            <el-table-column label width="35">
              <template slot-scope="scope">
                <el-radio
                  v-model="radioIdqb"
                  :label="scope.$index"
                  @change.native="handleRadioChangeqb(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="coupPacketName" label="券名称">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMoreqb"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Determineqb">确 定</el-button>
          <el-button @click="innerVisibleqb = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 选择员工 -->
    <div class="choice">
      <el-dialog
        append-to-body
        width="45%"
        title="选择员工"
        :visible.sync="innerVisiblery"
      >
        <el-form size="mini" label-width="200px">
          <el-form-item label="会员姓名\会员卡号\手机号">
            <div class="flex-between">
              <el-input style="width: 300px" v-model="queryArrry.search">
              </el-input>
              <el-button
                style="
                  width: 80px;
                  margin-left: 10px;
                  background-color: #f1f1f1;
                  color: #b6b388;
                "
                size="mini"
                icon="el-icon-search"
                @click="sysempselectEmpList()"
                >查询</el-button
              >
            </div>
          </el-form-item>
        </el-form>
        <div style="width: 100%">
          <el-table
            size="mini"
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryListry"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="loadry"
            v-loading="loadingry"
            infinite-scroll-disabled="onLoadingry"
            @select="handleSelectionChange"
          >
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column type="selection" label="选择" width="50">
            </el-table-column>
            <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
            <el-table-column prop="custName" label="会员姓名">
            </el-table-column>
            <el-table-column prop="mobile" label="手机号"> </el-table-column>
            <el-table-column prop="levelName" label="消费等级">
            </el-table-column>
            <el-table-column prop="regionName" label="所属区域">
            </el-table-column>
            <el-table-column prop="shopName" label="所属门店">
            </el-table-column>
            <el-table-column prop="serviceEmpName" label="维护品牌顾问">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMorery"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectemployees">确 定</el-button>
          <el-button @click="innerVisiblery = false">取 消</el-button>
        </div>
      </el-dialog>
      <div class="alteration">
        <el-dialog
          append-to-body
          width="50%"
          title="选择分组"
          :visible.sync="userGroupingShow"
          :close-on-click-modal="false"
        >
          <userGrouping
            @submit="getChangeProductInfo"
            @close="userGroupingShow = false"
            ref="scanCodeDialogRef"
          ></userGrouping>
        </el-dialog>
        <el-dialog
          append-to-body
          width="80%"
          title="券库详情"
          :visible.sync="quankuShow"
          :close-on-click-modal="false"
        >
          <quanku ref="quanku"></quanku>
        </el-dialog>
        <el-dialog
          append-to-body
          width="80%"
          title="券包详情"
          :visible.sync="quanbaoShow"
          :close-on-click-modal="false"
        >
          <quanbao ref="quanbao"></quanbao>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import userGrouping from "/src/components/userGrouping/index.vue";
import { queryLSelectApi } from "@/api/user"; // 会员等级接口
import { getcpyNo } from "@/utils/auth";
import { dateTimes } from "@/utils/auth";
import quanku from "/src/components/quanku.vue";
import quanbao from "/src/components/quanbao.vue";

import {
  shopQueryRegionApi,
  couponsGroupApi,
  couppacketJuanApi,
  marketingEitApi,
  marketingInsertApi,
  custselectCustList,
} from "@/api/marketing";
export default {
  name: "createdEditSingleTime",
  components: {
    userGrouping: userGrouping,
    quanku: quanku,
    quanbao: quanbao,
  },
  data() {
    return {
      quanbaoShow: false,
      quankuShow: false,
      checkbooksData: [],
      userGroupingShow: false,
      formData: {
        sendMode: 0,
        disIntervalDay: 0,
        issueTime: "",
        saleLimieFlag: 0,
        couponsKind: "",
        campaignName: "",
        custLvl: [],
        CCID: [],
        runTimeFlag: 0,
        presentedKind: 0,
        chaosong: "",
        listOfSomeStoresl: [],
        ccMap: [],
        actLimit: 0,
        custGrpName: "",
        customerGrpID: "",

      }, //表单数据
      radioChangeShop: true,
      // 用户类型
      customerType: [
        {
          value: 1,
          label: "所有会员",
        },
        {
          value: 2,
          label: "VIC会员",
        },
        {
          value: 3,
          label: "会员等级",
        },
        {
          value: 10,
          label: "本月生日会员",
        },
        {
          value: 11,
          label: "生日当天会员",
        },
        {
          value: 12,
          label: "本月注册会员",
        },
        {
          value: 13,
          label: "今年注册会员",
        },
        {
          value: 14,
          label: "会员分组",
        },
      ],

      radioDisabled1: false,
      selectShopData: [], // 门店树形图数据
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },

      queryList: [], //选择劵库弹窗数据

      queryArr: {
        state:0,
        couponsName: "", //卷名称
        couponsKind: "", //卷类型
        createTime: "",
        updateTime: "",
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      }, // 内层弹窗请求数据
      loading: false,
      innerVisible: false, //券库弹窗
      // 选择券库radio数据
      radioId: "",
      // 券库券分类ID
      couponsKind: "",
      templatei: {},
      // 内层弹窗请求数据
      queryArrqb: {
        state:0,
        pageSize: 50,
        pageNo: 1,
        pages: 0,
        coupPacketName: "",
      },
      innerVisibleqb: false,
      // 选择券包loadingqb
      loadingqb: false,
      // 选择券包弹窗数据
      queryListqb: [],
      radioIdqb: "", //券包是否选中
      innerVisiblery: false, //选择抄送人员弹窗
      // 选择人员参数
      queryArrry: {
        empCode: "", //员工编号
        empName: "", //员工姓名
        empKind: "", //员工类型
        shopNameOrCode: "", // 门店编号\名称
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      },
      loadingry: false,
      // 选择抄送人员数据
      queryListry: [],
      arrry: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      shopId: [],
      flag: 0,
      createFormRules: {
        campaignName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        joinCustomerFlag: [
          { required: true, message: "请选择用户类型", trigger: "blur" },
        ],
        runMonth: [
          { required: true, message: "请选择执行月", trigger: "blur" },
        ],
        runDay: [{ required: true, message: "请选择执行日", trigger: "blur" }],
        timeRange: [
          { required: true, message: "请选择执行时间", trigger: "blur" },
        ],
      },
    };
  },
  computed: {

    // 选择券库弹窗
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryArr.pageNo >= this.queryArr.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    // 选择券包弹窗
    isMoreqb() {
      //当起始页数等于总页数时停止加载
      return this.queryArrqb.pageNo >= this.queryArrqb.pages;
    },
    onLoadingqb() {
      return this.loadingqb || this.isMoreqb;
    },
    // 选择人员弹窗
    isMorery() {
      //当起始页数等于总页数时停止加载
      return this.queryArrry.pageNo >= this.queryArrry.pages;
    },
    onLoadingry() {
      return this.loadingry || this.isMorery;
    },
    ...mapState(["confirmButtonText", "cancelButtonText"]),
  },
  created() {
    this.ShopqueryRegionList();
    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
  },

  methods: {
    formRules() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
      return;
    },
    //选择人员列表触底加载
    loadry() {
      console.log("触底啦");
      this.loadingry = true;
      setTimeout(() => {
        this.queryArrry.pageSize += 50; //页数据+50
        this.sysempselectEmpList(); // 重新获取数据，此时页数据+50
      });
    },
    getChangeProductInfo(data) {
      console.log(data);
      this.formData.custGrpName = data.custGrpName;
      this.formData.customerGrpID = data.customerGrpID;
      this.userGroupingShow = false;
    },
    //接口调用成功返回
    success() {
      this.formData = {};
      this.disable = false;
      this.shopId = [];
      this.flag = 0;
      this.$emit("success");
    },
    //取消
    cancel() {
      this.formData = {};
      this.disable = false;
      this.shopId = [];
      this.flag = 0;
      this.$emit("close");
    },
    //监听用户选择
    changeJoinCustomerFlag(e) {
      if (e == 0) {
        this.formData.presentedKind = 0;
      }
    },
    //确定
    submit() {
      let data = {
        campaignName: this.formData.campaignName, //活动名称
        compaignKind: "6", //活动类型
        presentedKind: this.formData.presentedKind, //赠送内容
        joinCustomerFlag: this.formData.joinCustomerFlag, //用户类型
        custLvl: this.formData.custLvl.toString(), //会员等级
        sendMaxQty: this.formData.sendMaxQty, //发放数量
        presentedObjID:
          this.formData.presentedKind == 0
            ? this.formData.presentedObjIDqk
            : this.formData.presentedKind == 1
            ? this.formData.presentedObjIDqb
            : this.formData.presentedKind == 2
            ? this.formData.presentedObjID2
            : this.formData.presentedKind == 4
            ? this.formData.presentedObjID4
            : "", //券库id、券包id、积分、彩信id
        smsBody: this.formData.runTimeFlag == 3 ? this.formData.smsBody : "", //短信
        runTimeFlag: "1",
        runStartTime:
          this.formData.runTimeFlag == 1 ? this.formData.runStartTime : null, //执行时间
        sendMode: this.formData.sendMode,
        saleLimieFlag: 0, //定时发放时销售单限制
        disIntervalDay:
            this.formData.sendMode == 1
                ? this.formData.disIntervalDay
                : null,
        issueTime:
            this.formData.sendMode == 1 ? this.formData.issueTime : null, //执行时间
        CC1: this.formData.ccMap.length > 0 ? this.formData.ccMap[0] : "",
        CC2: this.formData.ccMap.length > 1 ? this.formData.ccMap[1] : "",
        CC3: this.formData.ccMap.length > 2 ? this.formData.ccMap[2] : "",
        startDate: dateTimes(this.formData.startDate), //开始执行日期
        endDate: dateTimes(this.formData.endDate), //结束执行日期
        actLimit: this.formData.actLimit,
        limitNum: this.formData.actLimit == 3 ? this.formData.limitNum : "",
        customerGrpID:
          this.formData.joinCustomerFlag == 14
            ? this.formData.customerGrpID
            : "", //会员分组id
      };
      if (this.flag == 2) {
        console.log("修改");
        data.campaignID = this.formData.campaignID;
        data.state = this.formData.state;
        marketingEitApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改活动失败!");
            return;
          } else {
            this.$message.success("修改活动成功!");
            this.success();
            // 隐藏创建弹窗
          }
        });
      } else {
        marketingInsertApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建活动失败!");
            return;
          } else {
            this.$message.success("创建活动成功!");
            this.success();

            // 隐藏创建弹窗
          }
        });
      }
    },
    // 获取区域门店
    ShopqueryRegionList() {
      shopQueryRegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择员工确定事件
    Selectemployees() {
      this.formData.chaosong = "";
      this.formData.ccMap = [];
      this.arrry.forEach((item) => {
        this.formData.chaosong += item.custName + ",";
        this.formData.ccMap.push(item.custID);
        // console.log(item.empName)
      });
      console.log("CCID", this.formData.ccMap);
      this.formData.chaosong = this.formData.chaosong.substring(
        0,
        this.formData.chaosong.length - 1
      );
      this.innerVisiblery = false;
    },
    //控制选择人员列表最多选择三个
    handleSelectionChange(selection, index) {
      this.checkNumber = selection.length;
      if (this.checkNumber >= 4) {
        this.$message({
          message: "只能选中3个!",
          type: "warning",
        });
        this.$refs.multipleTable.toggleRowSelection(index, false);
        selection.length = 3;
      }
      this.arrry = selection;
      console.log("arr", this.arrry);
    },
    // 选择人员数据请求
    async sysempselectEmpList() {
      await custselectCustList(this.queryArrry).then((res) => {
        this.queryListry = res.data.list;
        this.queryArrry.pages = res.data.pages;
        this.loadingry = false;
      });
    },
    // 券包点击跳转查看详情
    Juanbaobtn() {
      if (this.formData.presentedObjIDqb) {
        this.quanbaoShow = true;
        this.$nextTick(() => {
          this.$refs.quanbao.Rcouppacketview(this.formData.presentedObjIDqb);
        });
        // this.$router.push({
        //   path: "/VoucherSee",
        //   query: {
        //     mobile: this.formData.presentedObjIDqb,
        //   },
        // });
      }
    },
    // 选择券包弹窗radio选中数据
    handleRadioChangeqb(val) {
      console.log(val);
      this.templateiqb = val;
    },
    // 获取券包数据
    async Securitieslibraryqb() {
      await couppacketJuanApi(this.queryArrqb).then((res) => {
        this.queryListqb = res.data.list;
        this.queryArrqb.pages = res.data.pages;
        this.loadingqb = false;
      });
    },
    //点击选中劵库获取数据
    weachTherqb() {
      this.Securitieslibraryqb();
      this.innerVisibleqb = true;
    },
    // 选择券包确定事件
    Determineqb() {
      this.formData.presentedqb = this.templateiqb.coupPacketName;
      this.formData.presentedObjIDqb = this.templateiqb.coupPacketID;
      this.radioId = "";
      this.innerVisibleqb = false;
    },
    //券包触底加载
    loadqb() {
      this.loading = true;
      setTimeout(() => {
        this.queryArrqb.pageSize += 50; //页数据+50
        this.Securitieslibraryqb(); // 重新获取数据，此时页数据+50
      });
    },
    // 券包查询
    Seachbtnerqb() {
      this.Securitieslibraryqb();
    },
    // 券库点击跳转
    Juankubtn() {
      if (this.formData.presentedObjIDqk) {
        this.quankuShow = true;
        this.$nextTick(() => {
          this.$refs.quanku.RcouponsGroupDetail(this.formData.presentedObjIDqk);
        });
        // this.$router.push({
        //   path: "/ViewDetails",
        //   query: {
        //     mm: this.formData.presentedObjIDqk,
        //   },
        // });
      } else {
        return;
        // console.log("1111")
      }
    },
    // 选择券库弹窗radio选中数据
    handleRadioChange(val) {
      console.log(val);
      this.templatei = val;
    },
    // 选择券库确定事件
    determine() {
      this.couponsKind = this.templatei.couponsKind;
      this.formData.presentedqk = this.templatei.couponsName;
      this.formData.presentedObjIDqk = this.templatei.couponsGrpID;
      this.radioId = "";
      this.innerVisible = false;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryArr.pageSize += 50; //页数据+50
        this.Securitieslibrary(); // 重新获取数据，此时页数据+50
      });
    },
    //选择劵库数据请求
    async Securitieslibrary() {
      await couponsGroupApi(this.queryArr).then((res) => {
        this.queryList = res.data.list;
        this.queryArr.pages = res.data.pages;
        this.loading = false;
      });
    },
    //点击选中劵库获取数据
    weachTher() {
      this.Securitieslibrary();
      this.innerVisible = true;
    },
    shopRadioChange(index) {
      if (index == 0) {
        this.radioChangeShop = false;
      } else {
        this.radioChangeShop = true;
      }
    },
    parentHandleclick(e) {
      if (!e) {
        this.formData = {
          couponsKind: "",
          campaignName: "",
          custLvl: [],
          CCID: [],
          runTimeFlag: 0,
          presentedKind: 0,
          sendMode: 0,
          saleLimieFlag: 0,
          disIntervalDay: '',
          issueTime: '',
          chaosong: "",
          listOfSomeStoresl: [],
          ccMap: [],
          actLimit: 0,
          custGrpName: "",
          customerGrpID: "",
        };
        this.flag=0
        return;
      }
      if (e.flag == 2 || e.flag == 3) {
        this.flag = e.flag;
        this.formData.campaignID = e.data.campaignID;
        this.formData.state = e.data.state;
      }
      if (e.message == "success") {
        this.formData = e.data;
        let array = [];
        for (let i = 0; i < e.custLvl.length; i++) {
          array.push(e.custLvl[i].LevelID);
        }
        this.$set(this.formData, "custLvl", array);
        if (e.data.presentedKind == 0) {
          this.$set(this.formData, "presentedqk", e.data.couponsName);
          this.$set(this.formData, "presentedObjIDqk", e.data.presentedObjID);
        } else if (e.data.presentedKind == 1) {
          this.$set(this.formData, "presentedqb", e.data.coupPacketName);
          this.$set(this.formData, "presentedObjIDqb", e.data.presentedObjID);
        } else if (e.data.presentedKind == 2) {
          this.$set(this.formData, "presentedObjID2", e.data.presentedObjID);
        } else if (e.data.presentedKind == 4) {
          this.$set(this.formData, "presentedObjID4", e.data.presentedObjID);
        }
        this.formData.ccMap = [];
        this.formData.ccMap.push(e.data.cc1);
        this.formData.ccMap.push(e.data.cc2);
        this.formData.ccMap.push(e.data.cc3);
        this.formData.chaosong =
          e.data.cc1Name + "," + e.data.cc2Name + "," + e.data.cc3Name;
      } else {
        this.formData = {
          campaignName: "",
          custLvl: [],
          runTimeFlag: 0,
          presentedKind: 0,
          sendMode: 0,
          saleLimieFlag: 0,
          disIntervalDay: '',
          issueTime: '',
        };
      }
    },
    sendModeRadioChange(index) {
      console.log(index)
      if (index == 0) {
        this.formData.disIntervalDay = '';
        this.formData.issueTime = '';

      } else {

        this.formData.disIntervalDay = 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.el-button:hover {
  background-color: #b5b386;
  color: #f2f2f2;
}
/deep/.xiaoguo .el-input .el-input__inner {
  color: blue;
  text-decoration: underline;
}
</style>
